export const normalizeCommunityMemberPayload = (data: any) => {
  if (!data || typeof data !== 'object') return data;
  const normalized = { ...data };
  if (normalized.Organization && typeof normalized.Organization === 'object') {
    normalized.Organization = normalized.Organization._id ?? normalized.Organization;
  }
  return normalized;
};
